import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id", "name", "type", "disabled", "required", "aria-invalid", "autocomplete"]

import { computed, useAttrs, useTemplateRef } from "vue";
import { MaskInputOptions } from "maska";
import { vMaska } from "maska/vue";
import DsFormField, { stripFormFieldProps, DsFormFieldProps } from "./general/ds-form-field.vue";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import { DsFormFieldValueType } from "../models/ds-form-field-models";
import { SvgIcons } from "../../icon/types";

const iconSize = 24;


export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'ds-input',
  props: /*@__PURE__*/_mergeModels({
    id: {},
    label: {},
    tooltipText: {},
    supportingText: {},
    isError: { type: Boolean },
    errorMessage: {},
    floatingError: { type: Boolean },
    disabled: { type: Boolean },
    required: { type: Boolean },
    theme: {},
    isInStorybook: { type: Boolean },
    type: { default: "text" },
    inputMask: {},
    iconLeft: {},
    iconRight: {},
    rightIconClickFn: {},
    autocompleteAttr: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {


const { class: wrapperClass, ...attrs } = useAttrs();

/**
 * Model value of the input field.
 */
const modelValue = _useModel<T>(__props, "modelValue");

const props = __props;

const formFieldProps = computed(() => stripFormFieldProps(props));

const autocompleteAttr = computed(() => {
    if ((props.type === "password" || props.type === "email") && props.autocompleteAttr) {
        return props.autocompleteAttr;
    }
    return undefined;
});

const isInvalid = computed(() => !!props.errorMessage);

const inputRef = useTemplateRef<HTMLInputElement>("inputRef");

__expose({
    inputRef,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DsFormField, _mergeProps({
    class: ["ds-input", _unref(wrapperClass)]
  }, formFieldProps.value), _createSlots({
    default: _withCtx((inputAttrs) => [
      _withDirectives(_createElementVNode("input", _mergeProps({
        ref_key: "inputRef",
        ref: inputRef,
        id: _ctx.id,
        name: _ctx.id,
        type: _ctx.type,
        disabled: _ctx.disabled,
        required: _ctx.required,
        "aria-invalid": isInvalid.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
        autocomplete: autocompleteAttr.value
      }, { ...inputAttrs, ...attrs }), null, 16, _hoisted_1), [
        [_vModelDynamic, modelValue.value],
        [_unref(vMaska), _ctx.inputMask]
      ])
    ]),
    inputAfter: _withCtx((afterAttrs) => [
      _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(afterAttrs)))
    ]),
    _: 2
  }, [
    (_ctx.iconLeft)
      ? {
          name: "inputLeft",
          fn: _withCtx((leftAttrs) => [
            _createVNode(DsIcon, _mergeProps({
              name: _ctx.iconLeft,
              width: iconSize,
              height: iconSize,
              class: "ds-form-field__input-slot-icon"
            }, leftAttrs, { "is-in-storybook": _ctx.isInStorybook }), null, 16, ["name", "is-in-storybook"])
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.iconRight)
      ? {
          name: "inputRight",
          fn: _withCtx((rightAttrs) => [
            _createVNode(DsIcon, _mergeProps({
              name: _ctx.iconRight,
              width: iconSize,
              height: iconSize,
              class: ["ds-form-field__input-slot-icon", { 'ds-form-field__input-slot-icon--pointer': _ctx.rightIconClickFn }]
            }, rightAttrs, {
              onClick: _ctx.rightIconClickFn,
              "is-in-storybook": _ctx.isInStorybook
            }), null, 16, ["name", "class", "onClick", "is-in-storybook"])
          ]),
          key: "1"
        }
      : undefined
  ]), 1040, ["class"]))
}
}

})